import { render, staticRenderFns } from "./YearsSelector.vue?vue&type=template&id=131c4542"
import script from "./YearsSelector.vue?vue&type=script&lang=js"
export * from "./YearsSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports